import isPlainObject from 'lodash/isPlainObject';

import type { AppDispatch } from '@/store';

import { SUMMARY_CALCULATE_INVOICE_CLEAR, SUMMARY_CALCULATE_INVOICE_ERROR } from '@/constants/actionTypes';
import { extractErrorMessage } from '@/helpers/extractErrorMessage';

export const clearInvoiceDataAction = () => (dispatch: AppDispatch) => {
  dispatch({ type: SUMMARY_CALCULATE_INVOICE_CLEAR });
};

export const wrapMessage = (message?: string) => (message ? { message } : undefined);

export const calculateInvoiceErrorAction = (err: unknown) => async (dispatch: AppDispatch) => {
  dispatch({
    payload: isPlainObject(err) ? err : wrapMessage(extractErrorMessage(err)) || {},
    type: SUMMARY_CALCULATE_INVOICE_ERROR,
  });
};
